import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useDeleteKnowledgeItem = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ id }) => {
      const result = await restClient({
        url: `${prefix}/knowledge-item/${id}`,
        method: 'DELETE'
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['knowledgeItems']);
    }
  });
};
